module.exports = __webpack_public_path__ + "img/safemedical_logo_white.ed30f038.png";